import { render, staticRenderFns } from "./footer_default.vue?vue&type=template&id=78fa0a32&scoped=true&"
import script from "./footer_default.vue?vue&type=script&lang=js&"
export * from "./footer_default.vue?vue&type=script&lang=js&"
import style0 from "./footer_default.vue?vue&type=style&index=0&id=78fa0a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa0a32",
  null
  
)

export default component.exports